<template>
  <h2 class="text-n-0 heading-2">
    {{ t('inputs.pin-label') }}
  </h2>
  <pin-pad
    class="flex-1 max-h-[20rem] mt-6 mb-4 !items-start"
    :wrong-value="badCredentials"
    @complete="pinEntered"
  />
  <div v-if="customError" class="text-r-400">{{ customError }}</div>
  <l-button class="w-full max-w-72" size="small" type="text" @click="$emit('disablePin')">
    {{ t('login.login-email') }}
  </l-button>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

import { LButton } from '@last/core-ui/paprika'

import PinPad from '@/components/PinPad.vue'
import { useAuthStore } from '@/store/auth'
import { useStatusStore } from '@/store/status'

defineEmits<{
  disablePin: []
}>()

const { t } = useI18n()
const router = useRouter()
const authStore = useAuthStore()
const statusStore = useStatusStore()

const pin = ref<string>('')
const badCredentials = ref<boolean>(false)
const customError = ref<string>()

const isComplete = computed(() => pin.value.length === 4)

watch(pin, () => {
  if (isComplete.value) {
    startLogin()
  }
})

async function startLogin() {
  if (!isComplete.value) return
  try {
    await authStore.login({
      pin: pin.value
    })
    statusStore.performInitialSync()
    router.push({ name: 'employees' })
  } catch (error: any) {
    const res = await error.response?.json()
    if (res?.code === 'INVALID_DEVICE') {
      customError.value = t('login.invalid-device')
    } else {
      badCredentials.value = true
      customError.value = undefined
    }
  }
}

function pinEntered(input: string) {
  pin.value = input
}
</script>
